export const toBoolean = (value: string | boolean | undefined) => {
  if (typeof value === 'string') {
    return value === 'true';
  }
  return value;
};
